import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import Toast from 'vue-toastification'
import { useAuthStore } from '@/stores/auth'

// CSS imports
import './assets/css/main.css'
import 'vue-toastification/dist/index.css'

const app = createApp(App)
const pinia = createPinia()

// Toast options
const toastOptions = {
  position: 'top-right' as const,
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

app.use(pinia)
app.use(router)
app.use(Toast, toastOptions)

// Initialize auth store to restore session from localStorage
const authStore = useAuthStore()
authStore.initialize()

app.mount('#app')